import { alpha, Backdrop, Box, Button, CardMedia, CircularProgress, Grid, Hidden, IconButton, SelectChangeEvent, Skeleton, Switch, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TableSortLabel, Theme, Tooltip, Typography, useTheme } from "@mui/material";
import { useHistory, } from "react-router";
import { AIFActiveIcon, BlueEditIcon, BondsActiveIcon, CashAvailablePortfolioIcon, DownwardNegativeIcon, DropDownIcons, EditOulineIcon, EmailIcon, FailureIcon, InProgressIcon, InfoIconOutlined, InvestedValueIcon, JointHolderIcon, JointHoldersDisplayIcon, MutualFundsActiveIcon, PMSActiveIcon, Phoneicon, SIPReminderIcon, SuccessTickIcon, TransactionFailedIcon, UpWardPositiveIcon, ViewProfileIcon, WeightedAvgDaysIcon, ZeroStateArrow } from "../../assets/SvgIcons";
import { calculateOthersInPieChart, findRiskTolerance, formatCurrency, getAbbreviatedName, isModuleAllowed, isOnboardingTypeMinor, maskInfo, toINR ,getModeOfHoldingDisplay,} from "../../utils/utilityFunctions";
import { ProductDirectEquityIcon } from "../customSVGs";
import CustomGaugeChart from "../dashboard/chart/CustomGaugeChart";

import { Order, SortingObj, TableBodyData, TableHeaderData } from "./types";
import CustomTable from "./common/customTable";
import RecentRecommendationsTableBody from "./common/customTable/RecentRecommendationsTableBody";
import BreadCrum from "../../lib/BreadCrum";
import {
    getInvestorAllocation,
    getInvestorInfo,
    getLatestNotifications,
    getLatestRecommendations,
    setAppliedHoldingsFilters,
    setHoldingsActiveCategory,
    setSelectedHoldingsIds,
    setAppliedRecommendationsFilters, setRecommendationsActiveCategories,
    setCheckedHoldingSchemes,
    setSelectedHoldingsInfo,
    setSelectedAllHoldingsInfo,
    getPortfolioXirr
} from "../../redux-store/actions/investorProfile";
import { useDispatch, useSelector } from "react-redux";
import { RootStateType } from "../../redux-store/reducers";
import React, { useEffect, useState } from "react";
import { ENABLE_MF_TRANSACTIONS_POA_DOCUMENT_UPLOAD,  MPOWER_ACCOUNT_TYPE_MASTER, NO_DATA_ERROR_MESSAGE, USER_ROLES } from "../../utils/constant";
import { GetPortfolioXirrResponseBody, InvestorAllocationRes, InvestorInfoRes, LatestNotificationsRes, LatestRecommendationDataRes } from "../../redux-store/types/investorProfile";
import dayjs from "dayjs";
import CustomePieChart from "../dashboard/chart/CustomePieChart";
import { ErrorText } from "../dashboard/chart/CustomeLineChart";
import { BottomMenu } from "./common/BottomMenu";
import { setPortfolioHeldawayStatus, storeBseTxnStatus, storePortfolioList, storeSelectedPortfolio, storeSelectedPortfolioObj } from "../../redux-store/actions/portfolioFilter";
import { GetCartItemsCountResponseBody } from "../../redux-store/types/cart";
import { getCartItemsCount, setCartItemsCount } from "../../redux-store/actions/cart";
import { AssetClassDetailsRes, BenchmarkPerformanceRes } from "../../redux-store/types/products";
import { getAssetClassDetails, getBenchmarkPerformance } from "../../redux-store/actions/product";
import { PortfolioHealthChart } from "./PortfolioHealthChart";
import CustomDropdown from "./directEquity/directEquityOverview/CustomDropdown";
import { DropdownOption } from "./directEquity/types";
import { ZeroStateInvestment } from "./common/ZeroStateInvestment";
import { setApplicantDetails, setFamilyDetails, storeApplicationId, storeInterfaceCode, storeIsPortfolioAvailable, storeIwappId,storeInvApplicantId, storeApplicationType, storeApplicationIdForNomineeCheck } from "../../redux-store/actions/id";
import RiskScoreModal from "./RiskScoreModal";
import { setInvestorRmId } from "../../redux-store/actions/sessionData";
import SwitchSelection from "../../lib/formik/SwitchSelection";
import { GET_APPLICATION_SUCCESS } from "../../redux-store/types/application";
import { GetInvestorInfoBody, GetNotificationsResponseBody } from "../../redux-store/types/api-types";
import { showError } from "../../redux-store/actions/auth";
import { formatDate } from "../Notifications/Notifications";
import { getNotifications } from "../../redux-store/actions/notifications";
import { storeNotifications } from "../../redux-store/actions/navbarInfo";

const assetClassIconMap: Record<number, JSX.Element> = {
    0: <MutualFundsActiveIcon />,
    1: <ProductDirectEquityIcon />,
    2: <PMSActiveIcon />,
    3: <BondsActiveIcon />,
    4: <AIFActiveIcon />,
    5: <ProductDirectEquityIcon />
}

interface dashBoardNavigation {
    clientCode?: string | undefined
    portfoiloId?: string | undefined
    accountFilter?: number;
    accountType?: string
    uccCode?: string | null;
}

export const bseStarStatusColorMap: Record<string, string>= {
    pending: 'warning.500',
    active: 'success.500',
    failed: 'error.500',
    disabled: 'error.500'
}


export default function InvestorProfile(): JSX.Element {
    const { selectedPortfolio } = useSelector((store: RootStateType) => store.selectedPortfiolio);
    const { businessDate = "" } = useSelector((store: RootStateType) => store.navbarInfo);
    const { locale, currencyCode } = useSelector((store: RootStateType) => store.currencyInfo);

    const history = useHistory();
    const theme = useTheme();
    const { pathname: pathName, state } = history.location;
    const dispatch = useDispatch()
    const { palette } = useTheme()
    const { id: userId, role = '', permissions = [] } = useSelector((state: RootStateType) => state.auth);
    const { investorClientId, iwappRmId, clientInterfaceCode, applicationId, portfolio} = useSelector((state: RootStateType) => state.id)
    const { investorRmId = "" } = useSelector((state: RootStateType) => state.sessionData)
    const navState = state as dashBoardNavigation
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [tableHeaderMenu, setTableHeaderMenu] = useState<boolean>(false)
    const [tableHeaderKey, setTableHeaderKey] = useState<string>('status')

    const [recentRecommendationsData, setRecentRecommendationsData] = useState<TableBodyData[]>([])
    const [sortingObj, setSortingObj] = useState<SortingObj>({ order: "desc", orderBy: "recommendedDate" })
    const [notifications, setNotifications] = useState<LatestNotificationsRes[]>([]);
    const [investorInfo, setInvestorInfo] = useState<InvestorInfoRes>({
        name: '',
        emailId: '',
        mobileNumber: '',
        investorType: '',
        riskScore: 0,
        rm: '',
        investedValue: 0,
        marketValue: 0,
        "gain/loss": 0,
        weightedAvgDays: 0,
        profile: '',
        irr: 0,
        cashAvailable: 0,
        rmIwappId: '',
        portfolio: {
            isPortfolioHeldaway: false,
            portfolioId: '',
            portfolioName: '',
            portfolioAccountType: ''
        },
        portfolioList: [],
        applicantNames: [],
        clientInterfaceCode: null,
        cashflow: 0,
        return: 0,
        bseClientActivationStatus: null
    })

    const [assetLoading, setAssetLoading] = useState<boolean>(false);
    const [assetAllocation, setAssetAllocation] = useState<any>([]);
    const [isAssetAllocationError, setIsAssetAllocationError] = useState<boolean>(false);
    const [isPortfolioAllocationError, setIsPortfolioAllocationError] = useState<boolean>(false);
    const [portfolioLoading, setPortfolioLoading] = useState<boolean>(false);
    const [portfolioAllocation, setPortfolioAllocation] = useState<any>([]);
    const [assetClassObj, setAssetClassObj] = useState({
        mutualFunds: 0,
        directEquity: 0,
        pms: 0,
        bonds: 0,
        alternatives: 0,
        insurance: 0
    })
    const [benchmarkPerformanceLoader, setBenchMarkPerformanceLoader] = useState<boolean>(false);
    const [investorPortfolioOptions, setInvestorPortfolioOptions] = useState<Array<DropdownOption>>([])
    const [portfolioChangeFilter, setPortfolioChangeFilter] = useState<string | number>('');
    const [recommendationsLoading, setRecommendationsLoading] = useState<boolean>(false);
    const [investorInfoLoading, setInvestorInfoLoading] = useState<boolean>(false);
    const [riskScoreLoading, setRiskScoreLoading] = useState<boolean>(false);
    const [performanceData, setPerformanceData] = useState<BenchmarkPerformanceRes>({} as BenchmarkPerformanceRes);
    const [notificationsLoader, setNotificationsLoader] = useState<boolean>(false);
    const [portfolioDropdownOptions, setPortfolioDropdownOptions] = useState<string>('1');
    const [assetDropdownOptions, setAssetDropdownOptions] = useState<string>('1');
    const [zeroStateCheck, setZeroStateCheck] = useState<boolean>(false);
    const [investedValueCheck, setInvestedValueCheck] = useState<boolean>(false);
    const [assetClassLoader, setAssetClassLoader] = useState<boolean>(false);
    const [openRiskScore, setOpenRiskScore] = useState<boolean>(false);

    const [isToggleIrr, setToggleIrr] = useState<boolean>(false)
    const [toggleValue, setToggleValue] = useState<number>(0)
    const [isToggleLoading, setToggleLoading] = useState<boolean>(false)
    const formattedBusinessDate = businessDate ? dayjs(businessDate, 'DD/MM/YYYY').format('DD MMM, YYYY') : "-"

    const recommendationsTableData = async (order = "DESC", sort = "recommendedDate", value = '') => {
        // Handling Recommendations Api Call here
        try {
            setRecommendationsLoading(true);
            const recommendationsPayload = {
                clientCode: role === USER_ROLES.RM ? navState?.clientCode : investorClientId,
                order: order?.toUpperCase(),
                portfolioId: value ? value : navState?.portfoiloId,
                sort,
            }

            const recentRecommendationRes = await (dispatch(getLatestRecommendations(recommendationsPayload)) as unknown as Promise<LatestRecommendationDataRes>)


            const modifiedRecommendationsForTable = recentRecommendationRes?.FinalData?.map((recommendation) => ({
                ...recommendation,
                id: recommendation?.id,
                schemeName: recommendation?.schemeName,
                status: recommendation?.status ?? "-",
                transactionType: recommendation?.buySellType,
                amount: toINR({ value: recommendation?.recommendedAmount, locale, currencyCode }),
                date: recommendation?.recommendedDate ? dayjs(recommendation?.recommendedDate, "DD/MM/YYYY").format("DD MMM, YY") : '-'
            }))


            setRecentRecommendationsData(modifiedRecommendationsForTable)
        } catch (e) {
            console.log("ERROR IN FETCHING RECOMMENDATIONS", e);
        } finally {
            setRecommendationsLoading(false);
        }


    }

    const getInvestorNotifications = async (value = '') => {
        try {
            setNotificationsLoader(true);
            const notificationsRes = await (dispatch(getLatestNotifications({
                clientCode: role === USER_ROLES.RM ? navState?.clientCode : investorClientId,
                portfolioId: value ? value : (navState?.portfoiloId || ""),
                limit: 5
            })) as unknown as Promise<Array<LatestNotificationsRes>>)

            setNotifications(notificationsRes ?? [])
        } catch (e) {
            console.log('error', e);
        } finally {
            setNotificationsLoader(false);
        }

    }

    const fetchAssetAllocation = async (portfolioValue = '', categoryValue = 1, currentRmId = "") => {
        try {
            setAssetLoading(true);
            setAssetAllocation([])
            const assetAllocationRes: any = (await dispatch(getInvestorAllocation({
                clientCode: role === USER_ROLES.RM ? navState?.clientCode : investorClientId,
                category: categoryValue === 1 ? 'Asset Group' : 'Asset Class',
                rmId: `${currentRmId ?? ''}`,
                portfolio: portfolioValue
            }))) as unknown as Promise<InvestorAllocationRes>;
            if (assetAllocationRes?.isSuccess) {
                setIsAssetAllocationError(false)
                setAssetAllocation({ ...assetAllocationRes, result: { ...assetAllocationRes?.result } })
            } else {
                setIsAssetAllocationError(true)
            }

        } catch (e) {
            setAssetAllocation([])
            setIsAssetAllocationError(true)
            console.log("ERROR", e);
        } finally {
            setAssetLoading(false)
        }
    }

    const fetchPortfolioAllocation = async (portfolioValue = '', categoryValue = 1, currentRmId = "") => {
        try {
            setPortfolioLoading(true);
            setPortfolioAllocation([])
            const portfolioAllocationRes: any = (await dispatch(getInvestorAllocation({
                clientCode: role === USER_ROLES.RM ? navState?.clientCode : investorClientId,
                category: categoryValue === 1 ? 'Sector' : 'Issuer',
                rmId: `${currentRmId ?? ''}`,
                portfolio: portfolioValue
            }))) as unknown as Promise<InvestorAllocationRes>;

            if (portfolioAllocationRes?.isSuccess) {
                setIsPortfolioAllocationError(false);
                setPortfolioAllocation({ ...portfolioAllocationRes, result: { ...portfolioAllocationRes?.result } })

            } else {
                setIsPortfolioAllocationError(true);
            }
        } catch (e) {
            setPortfolioAllocation([])
            console.log("Error", e);
            setIsPortfolioAllocationError(true);
        } finally {
            setPortfolioLoading(false)
        }
    }

    const fetchBenchMarkPerformance = async (value: string | number = '', currentRmId = "") => {
        try {
            setBenchMarkPerformanceLoader(true);
            const investor360PerformanceRes = await (dispatch(getBenchmarkPerformance({
                clientCode: role === USER_ROLES.RM ? navState?.clientCode : investorClientId,
                portfolioId: value ? `${value}` : selectedPortfolio?.value,
                rmId: `${currentRmId ?? ''}`,
            })) as unknown as Promise<BenchmarkPerformanceRes>)
            setPerformanceData(investor360PerformanceRes);
        } catch (e) {
            console.log('error', e);
        } finally {
            setBenchMarkPerformanceLoader(false);
        }
    }

    const fetchAssetClassDetails = async (value: string | number = '', currentRmId = "") => {
        try {
            setAssetClassLoader(true);
            const assetClassRes = await (dispatch(getAssetClassDetails({
                clientCode: role === USER_ROLES.RM ? navState?.clientCode : investorClientId,
                portfolioId: value ? `${value}` : selectedPortfolio?.value,
                rmId: `${currentRmId ?? ''}`,
            })) as unknown as Promise<AssetClassDetailsRes>)
            setAssetClassObj({ ...assetClassObj, mutualFunds: assetClassRes?.result?.mutual_funds, alternatives: assetClassRes?.result?.alternates, bonds: assetClassRes?.result?.debt, directEquity: assetClassRes?.result?.direct_equity, pms: assetClassRes?.result?.pms, insurance: assetClassRes?.result?.insurance });
        } catch (e) {
            console.log('error', e);
        } finally {
            setAssetClassLoader(false);
        }
    }

    const callInvestorInfo = async (value: string | number = '') => {
        try {
            setInvestedValueCheck(false);
            setZeroStateCheck(false);
            setInvestorInfoLoading(true);
            if (value) {
                setRiskScoreLoading(false);
            } else {
                setRiskScoreLoading(true);
            }

            const investorInfoRes = await fetchInvestorInfoApi({
                clientCode: role === USER_ROLES.RM ? navState?.clientCode ?? "" : investorClientId,
                portfolio: value ? value : (portfolio ||selectedPortfolio?.value || navState?.portfoiloId || ""),
                applicationId: applicationId,
                rmId: `${iwappRmId}`,
                accountType: navState?.accountType ?? 'EXY',
                uccCode: navState?.uccCode ?? ''
            })


            dispatch(storeIsPortfolioAvailable(investorInfoRes?.isSuccess ?? false))
            dispatch({ type: GET_APPLICATION_SUCCESS, body: investorInfoRes?.application });
            const primaryApplicant = (investorInfoRes?.application?.applicants ?? []).find(obj => obj.applicant_type === "1") ?? {}
            dispatch(storeInvApplicantId({ applicantId: investorInfoRes?.application?.applicants?.[0]?.id ?? '' }));
            dispatch(storeApplicationType({ applicationType: investorInfoRes?.application?.applicationType ?? '', investorName: investorInfoRes?.name ?? '', status: investorInfoRes?.application?.applicants?.[0]?.status ?? '', onboardingType: (investorInfoRes?.application?.applicants?.[0]?.onboardingType ?? ''), investorType: (investorInfoRes?.application?.applicants[0]?.investorType ?? '') as unknown as string }));
            dispatch(setInvestorRmId(investorInfoRes?.rmIwappId ?? ''))
            const modifiedInvestorInfoRes = {
                ...investorInfoRes,
                name: maskInfo(investorInfoRes?.name),
                emailId: maskInfo(investorInfoRes?.emailId),
                mobileNumber: maskInfo(investorInfoRes?.mobileNumber),
                countryCode:investorInfoRes?.application?.applicants[0]?.countryCode
            }
            if (modifiedInvestorInfoRes?.investedValue === 0) {
                setInvestedValueCheck(true);
            }
            setInvestorInfo(modifiedInvestorInfoRes)
            setToggleValue(Number(modifiedInvestorInfoRes?.return ?? ""))
            const portfolioObj = modifiedInvestorInfoRes?.portfolioList?.map((portfolio) => {
                return (
                    { label: maskInfo(portfolio?.portfolioName), value: portfolio?.portfolioId }
                )
            }) ?? [{
                label: '',
                value: ''
            }]
            setInvestorPortfolioOptions(portfolioObj);
            dispatch(setFamilyDetails({
                familyId: investorInfoRes?.familyId ?? "",
                familyName: investorInfoRes?.familyName ?? "",
            }));
            dispatch(setApplicantDetails({
                panNo: primaryApplicant?.panNo ?? "",
                email: primaryApplicant?.email ?? "",
                mobile: primaryApplicant?.mobile ?? "",
                countryCode: primaryApplicant?.countryCode ?? ""
            }))
            setPortfolioChangeFilter(modifiedInvestorInfoRes?.portfolio?.portfolioId)
            dispatch(storeSelectedPortfolioObj(modifiedInvestorInfoRes?.portfolio ?? {}))
            dispatch(storeBseTxnStatus(`${modifiedInvestorInfoRes?.bseClientActivationStatus ?? ''}`.toLowerCase() === 'active'))
            dispatch(storePortfolioList(portfolioObj))
            dispatch(setPortfolioHeldawayStatus(modifiedInvestorInfoRes?.portfolio?.isPortfolioHeldaway ?? false))
            dispatch(storeInterfaceCode(modifiedInvestorInfoRes.clientInterfaceCode ?? modifiedInvestorInfoRes?.clientCode ?? ''));
            // dispatch(storeApplicationId({ applicationId: investorInfoRes?.applicationId ?? '' })); // not working in case of RM
            // dispatch(storeApplicationId({ applicationId: investorInfoRes?.application?.id ?? '' }))
            dispatch(storeApplicationIdForNomineeCheck({ applicationIdForNomineeCheck: investorInfoRes?.application?.id ?? '' }))
            if (investorInfoRes.isSuccess) {
                // dispatch(storeIwappId({ iwappRmId: investorInfoRes?.rmIwappId ?? '' }));
                dispatch(storeSelectedPortfolio(modifiedInvestorInfoRes?.portfolio ? portfolioObj?.filter((item) => item.value === modifiedInvestorInfoRes?.portfolio?.portfolioId)[0] : {
                    label: '',
                    value: ''
                }))
                const investorPortfolio = portfolioObj.filter((item) => item.value === modifiedInvestorInfoRes?.portfolio?.portfolioId)[0].value;

                if (role === USER_ROLES.INVESTOR) {
                    const { isSuccess, cartItemsCount } = await (dispatch(getCartItemsCount({
                        clientCode: clientInterfaceCode ? clientInterfaceCode : investorClientId,
                        portfolioId: portfolioObj.filter((item) => item.value === modifiedInvestorInfoRes?.portfolio?.portfolioId)[0].value
                    })) as unknown as Promise<GetCartItemsCountResponseBody>)

                    if (isSuccess) {
                        dispatch(setCartItemsCount(cartItemsCount));
                    }
                }
                if (role === USER_ROLES.INVESTOR) {
                    const notificationsPayload = {
                        rmId: [USER_ROLES.RM].includes(role) ? [`${iwappRmId}`] : [],
                        category: [],
                        clientCode: [USER_ROLES.INVESTOR].includes(role) ? [clientInterfaceCode] : [],
                        limit: 3,
                        page: 1,
                        sort: 'notificationTimestamp',
                        order: 'DESC'
                    }
                    const getNotificationsData = (await dispatch(getNotifications(notificationsPayload))) as unknown as GetNotificationsResponseBody;
                    dispatch(storeNotifications(getNotificationsData.data ?? []));
                }

                await Promise.allSettled([recommendationsTableData('DESC', 'recommendedDate', value ? `${value}` : (investorPortfolio || navState?.portfoiloId)),
                getInvestorNotifications(value ? `${value}` : (investorPortfolio || navState?.portfoiloId)),
                fetchAssetAllocation((value ? `${value}` : investorPortfolio || navState?.portfoiloId), 1, `${investorInfoRes?.rmIwappId ?? ''}`),
                fetchPortfolioAllocation((value ? `${value}` : investorPortfolio || navState?.portfoiloId), 1, `${investorInfoRes?.rmIwappId ?? ''}`),
                fetchBenchMarkPerformance(value ? value : (investorPortfolio || navState?.portfoiloId), `${investorInfoRes?.rmIwappId ?? ''}`)])
                fetchAssetClassDetails(value ? value : (investorPortfolio || navState?.portfoiloId), `${investorInfoRes?.rmIwappId ?? ''}`)
            }
            else {
                setInvestorInfo(investorInfoRes);
                setZeroStateCheck(true);
                return;
            }
        } catch (e) {
            console.log("ERROR IN FETCHING INVESTOR INFO", e);
        } finally {
            setInvestorInfoLoading(false);
            setRiskScoreLoading(false)
        }

    }

    const fetchInvestorInfoApi = async ({
        clientCode,
        portfolio,
        applicationId,
        rmId,
        accountType,
        uccCode,
    }: GetInvestorInfoBody) => {
        return await (dispatch(getInvestorInfo({
            clientCode,
            portfolio,
            applicationId,
            rmId,
            accountType,
            uccCode,
        })) as unknown as Promise<InvestorInfoRes>)
    }


    useEffect(() => {
        const fetchInvestorInfo = async () => {
            await callInvestorInfo()
        }
        fetchInvestorInfo()
    }, [])


    const assestPercentages = [
        {
            "name": "Mutual Funds",
            "value": Math.round(assetClassObj?.mutualFunds ?? 0),
            isShow: isModuleAllowed({ value: 'MFOrders', compareArr: permissions, objKey: "permissonCode" }) ||
                isModuleAllowed({ value: 'OrderRecommend', compareArr: permissions, objKey: "permissonCode" }),
            isShowValue: true
        },
        {
            "name": "Direct Equity",
            "value": Math.round(assetClassObj?.directEquity ?? 0),
            isShow: isModuleAllowed({ value: "DirectEQDashboard", compareArr: permissions, objKey: "permissonCode" }),
            isShowValue: true
        },
        {
            "name": "PMS",
            "value": Math.round(assetClassObj?.pms ?? 0),
            isShow: isModuleAllowed({ value: "PMSDashboard", compareArr: permissions, objKey: "permissonCode" }),
            isShowValue: true
        },
        {
            "name": "Debt",
            "value": Math.round(assetClassObj?.bonds ?? 0),
            isShow: isModuleAllowed({ value: "DebtDashboard", compareArr: permissions, objKey: "permissonCode" }),
            isShowValue: true
        },
        {
            "name": "Alternates",
            "value": Math.round(assetClassObj?.alternatives ?? 0),
            isShow: isModuleAllowed({ value: "AIFDashboard", compareArr: permissions, objKey: "permissonCode" }),
            isShowValue: true
        },
        {
            "name": "Insurance",
            "value": Math.round(assetClassObj?.insurance ?? 0),
            isShow: isModuleAllowed({ value: "INSDashboard", compareArr: permissions, objKey: "permissonCode" }),
            isShowValue: false
        }
    ]



    const investorPortfolioCards = [
        {
            label: "Invested Value",
            value: investorInfo?.investedValue ? (investorInfo?.investedValue < 0 ? `- ${formatCurrency({ value: Math.abs(investorInfo?.investedValue), locale, currencyCode })}` : `${formatCurrency({ value: investorInfo?.investedValue, locale, currencyCode })}`) : `${formatCurrency({ value: 0, locale, currencyCode })}`
        },
        {
            label: "Trail Assets AUM",
            value: investorInfo?.trailAssetsAUM ? (investorInfo?.trailAssetsAUM < 0 ? `- ${formatCurrency({ value: Math.abs(investorInfo?.trailAssetsAUM), locale, currencyCode })}` : `${formatCurrency({ value: investorInfo?.trailAssetsAUM, locale, currencyCode })}`) : `${formatCurrency({ value: 0, locale, currencyCode })}`
        },
        {
            label: "Weighted Avg Days",
            value: `${(investorInfo?.weightedAvgDays ?? 0).toFixed(2)}`

        }
    ]

    const tableHeaderData: TableHeaderData[] = [
        {
            id: "schemeName",
            label: "SCHEME NAME",
            align: "left",
            isSortable: true,
            key: 'schemeName'
        },
        {
            id: "status",
            label: "STATUS",
            align: "center",
            isSortable: false,
            key: 'status'
        },
        {
            id: "buySellType",
            label: "TRANSACTION TYPE",
            align: "center",
            isSortable: false,
            key: 'buySellType'
        },
        {
            id: "recommendedAmount",
            label: "AMOUNT",
            align: "center",
            isSortable: true,
            key: 'recommendedAmount'
        },
        {
            id: "recommendedUnits",
            label: "UNITS",
            align: "center",
            isSortable: true,
            key: 'recommendedUnits'
        },
        {
            id: "recommendedDate",
            label: "DATE",
            align: "center",
            isSortable: true,
            key: 'recommendedDate'
        }
    ]

    const handleTableSorting = async (orderBy: string, order: Order) => {
        try {
            setSortingObj({ order, orderBy })
            recommendationsTableData(order, orderBy, selectedPortfolio?.value)
        } catch (e) {
            console.log("Error: ", e)
        }
    }

    const style: any = { color: palette.text.secondary, fontWeight: 500, fontSize: '14px', textTransform: 'uppercase', textWrap: 'nowrap', paddingRight: 0, paddingLeft: 0 }

    const handleAssetClassNavigation = (index: number) => {
        dispatch(setRecommendationsActiveCategories({
            primaryCategory: "New Purchase",
            secondaryCategory: "Lumpsum"
        }))
        dispatch(setSelectedAllHoldingsInfo([]))
        dispatch(setAppliedRecommendationsFilters([]))

        dispatch(setAppliedHoldingsFilters([]))
        dispatch(setHoldingsActiveCategory("All"))
        dispatch(setSelectedHoldingsIds([]))
        dispatch(setCheckedHoldingSchemes([]))
        dispatch(setSelectedHoldingsInfo([]))



        if (index === 0) {
            history.push(`${pathName}/mutual-fund?tab=Overview`, {
                clientCode: role === USER_ROLES.RM ? navState?.clientCode : investorClientId,
                portfolioId: navState?.portfoiloId
            });
        }
        else if (index === 1) {
            history.push(`${pathName}/direct-equity?tab=Overview`, {
                clientCode: role === USER_ROLES.RM ? navState?.clientCode : investorClientId
            });
        }
        else if (index === 2) {
            history.push(`${pathName}/pms?tab=Overview`, {
                clientCode: role === USER_ROLES.RM ? navState?.clientCode : investorClientId
            });
        }
        else if (index === 3) {
            history.push(`${pathName}/debt?tab=Overview`, {
                clientCode: role === USER_ROLES.RM ? navState?.clientCode : investorClientId
            });
        }
        else if (index === 4) {
            history.push(`${pathName}/alternates?tab=Overview`, {
                clientCode: role === USER_ROLES.RM ? navState?.clientCode : investorClientId
            });
        } else if (index === 5) {
            history.push(`${pathName}/insurance`, {
                clientCode: role === USER_ROLES.RM ? navState?.clientCode : investorClientId
            });
        }
    }

    const initialRouter = pathName.split('/').filter((item) => item !== '')

    const routerPath = [
        {
            name: 'Dashboard',
            path: '/dashboard',
            state: {
                accountFilter: navState?.accountFilter,
            },
            handleClick: () => {
                dispatch(storeSelectedPortfolio({
                    label: '',
                    value: ''
                }))
                dispatch(storePortfolioList([]))
            }
        },
        {
            name: `${initialRouter[1]}`,
            path: `/${initialRouter[0]}/${initialRouter[1]}`,
            state: {
                clientCode: role === USER_ROLES.RM ? navState?.clientCode : investorClientId
            }
        },
    ]


    const handleHeader = () => {
        setTableHeaderMenu(true)
    }

    const handleHeaderDropdownChange = async (event: SelectChangeEvent) => {
        await callInvestorInfo(event.target.value);
    }

    // const handlePortfolioChange = async (event: SelectChangeEvent) => {
    //     setPortfolioDropdownOptions(event.target.value);
    //     await fetchPortfolioAllocation(selectedPortfolio?.value, Number(event.target.value));
    // }
    const handlePortfolioChange = async (value: string | number) => {
        setPortfolioDropdownOptions(value as string);
        await fetchPortfolioAllocation(selectedPortfolio?.value, Number(value), `${investorRmId ?? ""}`);
    }

    // const handleAssetDropdownChange = async (event: SelectChangeEvent) => {
    //     setAssetDropdownOptions(event.target.value);
    //     await fetchAssetAllocation(selectedPortfolio?.value, Number(event.target.value));
    // }
    const handleAssetDropdownChange = async (value: string | number) => {
        setAssetDropdownOptions(value as string);
        // await fetchAssetAllocation(selectedPortfolio?.value, Number(value) );
        await fetchAssetAllocation(selectedPortfolio?.value, Number(value), `${investorRmId ?? ""}`);
    }

    const openEditRiskProfile = () => {
        // setOpenRiskScore(true);
        history.push(`${pathName}/edit-risk-profile`, {
            clientCode: role === USER_ROLES.RM ? navState?.clientCode : investorClientId
        })
    }

    const closeEditRiskProfile = () => {
        setOpenRiskScore(false);
    }

    const handleSystematicPlansBtn = () => {
        history.push(`${pathName}/mutual-fund?tab=Systematic Plans&type=SIP`, {
            clientCode: role === USER_ROLES.RM ? navState?.clientCode : investorClientId
        });
    }

    const handleToggleChange = async (event: React.ChangeEvent<HTMLInputElement>, checked: boolean) => {
        try {
            setToggleLoading(true)

            if (checked) {
                const response = await (dispatch(getPortfolioXirr({
                    rmId: `${iwappRmId}`,
                    clientCode: role === USER_ROLES.RM ? navState?.clientCode ?? "" : investorClientId,
                    portfolioId: selectedPortfolio?.value || navState?.portfoiloId || "",
                })) as unknown as Promise<GetPortfolioXirrResponseBody>)

                if (!response?.isSuccess) {
                    dispatch(showError(response?.message ?? ""))
                    return
                }

                if (response?.isSuccess) {
                    setToggleIrr(checked)
                    setToggleValue(Number(response?.xirr ?? ""))
                }
            } else {
                const response = await fetchInvestorInfoApi({
                    clientCode: role === USER_ROLES.RM ? navState?.clientCode ?? "" : investorClientId,
                    portfolio: selectedPortfolio?.value || navState?.portfoiloId || "",
                    applicationId: applicationId,
                    rmId: `${iwappRmId}`,
                    accountType: navState?.accountType ?? 'EXY'
                })

                if (response.isSuccess) {
                    setToggleIrr(checked)
                    setToggleValue(Number(response?.return ?? ""))
                }
            }

        } catch (e) {
            console.log("Error: ", e)
        } finally {
            setToggleLoading(false)
        }
    }



    return (
        <>
            <Backdrop
                sx={(theme: Theme) => ({
                    color: theme.palette.common.white,
                    zIndex: theme.zIndex.drawer + 1
                })}
                open={isToggleLoading}
            >
                <CircularProgress sx={(theme: Theme) => ({ color: theme.palette.primary[500] })} />
            </Backdrop>
            <Box>
                {/* Custom Dropdown */}
                <Box component={'section'} sx={{ display: 'flex', justifyContent: 'space-between', mb: '15px', flexWrap: 'wrap', flexDirection: 'row', }} >
                    {role === USER_ROLES.RM && (
                        <BreadCrum array={routerPath} />
                    )}
                    {role === "investor" && (
                        <Typography
                            variant="h1"
                            sx={(theme: Theme) => ({
                                color: theme.palette.text.primary,
                                lineHeight: "32.5px"
                            })}
                        >
                            Dashboard
                        </Typography>
                    )}

                    {investorPortfolioOptions.length > 0
                        &&
                        (
                            <Box>
                                <CustomDropdown selectedValue={selectedPortfolio?.value} dropdownOptions={investorPortfolioOptions} handleValueChange={handleHeaderDropdownChange} isLoading={investorInfoLoading} />
                            </Box>
                        )
                    }
                </Box>

                <Box
                    sx={{
                        display: "flex",
                        justifyContent: "flex-end",
                        alignItems: "center",
                        mb: '10px'
                    }}
                >
                    <Button
                        onClick={handleSystematicPlansBtn}
                        sx={(theme: Theme) => ({
                            borderRadius: "10px",
                            padding: "5px 10px",
                            color: theme.palette.primary[500],
                            ...theme.typography.body_500
                        })}
                        disabled={investorInfoLoading || (`${investorInfo?.bseClientActivationStatus ?? ''}`.toLowerCase() !== 'active') || !investorInfo?.isSuccess}
                    >
                        Go to Systematic Plans
                    </Button>
                </Box>

                {/* User Profile and Risk Score */}
                <Grid container columnSpacing={'25px'}>

                    {/* User Profile and Cards */}
                    <Grid item md={12} lg={8}>
                        <Box component={'section'} sx={(theme: Theme) => ({
                            padding: '20px 30px',
                            borderRadius: '10px',
                            // borderRadius: '25px',
                            // padding: '35px',
                            // boxShadow: `0px 4px 10px ${alpha(theme.palette.common.black, 0.05)}`,
                            // border: `3px solid ${theme.palette.stroke.main}`,
                            background: theme.palette.common.white
                        })}>

                            {/* User Profile */}
                            {investorInfoLoading ? <Grid container sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', borderBottom: 0, rowGap: '10px' }}>
                                <Grid item lg={6} md={12}>
                                    {/* Investor Name */}
                                    <Box sx={{ display: 'flex', columnGap: '15px', mb: '35px' }}>
                                        <Skeleton animation="wave" variant="circular" width={58} height={58} />
                                        <Box >
                                            <Skeleton animation="wave" sx={{ width: '200px' }} />
                                            <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                                <Skeleton animation="wave" sx={{ width: '50%' }} />
                                                <Skeleton animation="wave" variant="circular" sx={{ width: '4px', height: '4px', ml: '3px', mr: '3px' }} />
                                                <Skeleton animation="wave" sx={{ width: '50%' }} />
                                            </Box>
                                        </Box>
                                    </Box>

                                    {/* Investor Details */}
                                    <Box component={'section'}>
                                        <Box sx={{ display: 'flex', alignItems: 'center', columnGap: '10px', mb: '15px' }}>
                                            <Skeleton animation="wave" variant="rectangular" sx={{ width: '15px', height: '15px' }} />
                                            <Skeleton animation="wave" sx={{ width: '120px' }} />
                                        </Box>
                                        <Box sx={{ display: 'flex', alignItems: 'center', columnGap: '10px', mb: '15px' }}>
                                            <Skeleton animation="wave" variant="rectangular" sx={{ width: '15px', height: '15px' }} />
                                            <Skeleton animation="wave" sx={{ width: '120px' }} />
                                        </Box>
                                        <Box sx={{ display: 'flex', alignItems: 'center', columnGap: '10px' }}>
                                            <Skeleton animation="wave" variant="rectangular" sx={{ width: '15px', height: '15px' }} />
                                            <Skeleton animation="wave" sx={{ width: '120px' }} />
                                        </Box>

                                    </Box>
                                </Grid>
                                <Grid item lg={6} md={12}>
                                    <Box sx={{ mb: { lg: '35px', xs: '10px' } }}>

                                        <Skeleton animation="wave" variant="text" />
                                        <Skeleton animation="wave" />
                                        <Skeleton animation="wave" height={'40px'} />
                                    </Box>
                                    <Box sx={{ display: 'flex', columnGap: '35px', flexDirection: 'row' }}>
                                        <Box>
                                            <Skeleton animation="wave" sx={{ width: '80px' }} />
                                            <Skeleton animation="wave" sx={{ width: '100px' }} />
                                        </Box>
                                        <Box>
                                            <Skeleton animation="wave" sx={{ width: '80px' }} />
                                            <Skeleton animation="wave" sx={{ width: '100px' }} />
                                        </Box>
                                        <Box>
                                            <Skeleton animation="wave" sx={{ width: '80px' }} />
                                            <Skeleton animation="wave" sx={{ width: '100px' }} />
                                        </Box>
                                    </Box>
                                </Grid>
                            </Grid>
                                :
                                <Grid container sx={(theme: Theme) => ({ display: 'flex', justifyContent: 'space-between', alignItems: 'center', pb: '30px', borderBottom: `0.5px solid ${theme.palette.text.secondary}B2`, rowGap: '10px' })}>
                                    <Grid item md={7} sm={12}>
                                        {/* Investor Name */}
                                        <Box sx={{ display: 'flex', columnGap: '15px', mb: '35px' }}>
                                            <Box sx={(theme: Theme) => (
                                                {
                                                    backgroundColor: theme.palette.primary[50],
                                                    borderRadius: '50%',
                                                    width: '58px',
                                                    height: '58px',
                                                    textAlign: 'center'
                                                    // padding: '15px'
                                                }
                                            )}>
                                                <Typography variant="h1" sx={(theme: Theme) => ({
                                                    fontSize: '24px',
                                                    letterSpacing: '0.02px',
                                                    padding: '14px 14px 14px 12px',
                                                    color: theme.palette.primary[500]
                                                })}>{getAbbreviatedName(isOnboardingTypeMinor(`${investorInfo?.application?.onboardingType ?? ''}`) ? (investorInfo?.application?.applicants.find((applicant) => applicant.applicant_type === "1")?.minorName ?? '') : investorInfo?.name)}</Typography>
                                            </Box>
                                            <Box>
                                                <Typography variant="h1" color='text.primary' >{isOnboardingTypeMinor(`${investorInfo?.application?.onboardingType ?? ''}`) ? (investorInfo?.application?.applicants.find((applicant) => applicant.applicant_type === "1")?.minorName ?? '') : investorInfo?.name}</Typography>
                                                {ENABLE_MF_TRANSACTIONS_POA_DOCUMENT_UPLOAD && (
                                                    <Box sx={{ marginTop: "3px" }}>
                                                        <Typography
                                                            component='span'
                                                            variant="body_500"
                                                            color='text.secondary'
                                                            sx={{ mr: '10px' }}
                                                        >
                                                            Account Type: {MPOWER_ACCOUNT_TYPE_MASTER[investorInfo?.portfolio?.portfolioAccountType ?? ""]}
                                                        </Typography>
                                                    </Box>
                                                )}
                                                <Box sx={{ display: 'flex', alignItems: 'center', marginTop: "3px" }}>
                                                    <Typography component={'span'} variant="body_500" color='text.secondary' sx={{ mr: '10px' }}>
                                                        {getModeOfHoldingDisplay(investorInfo?.investorType)??"-"}
                                                    </Typography>

                                                    {`${investorInfo?.portfolio?.portfolioAccountType ?? ''}`.toLowerCase() !== "hldawy" &&
                                                        <>
                                                            <Box component={'span'}
                                                                sx={{
                                                                    borderRadius: '20%', width: '4px', height: '4px', mr: '10px', backgroundColor: 'text.secondary',
                                                                }} />
                                                            <Button sx={(theme: Theme) => (
                                                                {
                                                                    color: theme.palette.primary[500],
                                                                    padding: 0,
                                                                    '&:hover': {
                                                                        backgroundColor: theme.palette.common.white,
                                                                        '& .view-profile-icon': {
                                                                            transform: 'rotate(-45deg)',
                                                                            transition: 'transform 0.3s ease', // Smooth transition for rotation
                                                                        }
                                                                    }

                                                                }
                                                            )}>
                                                                <Typography onClick={() => history.push(`${pathName}/view-profile`, {
                                                                    // clientCode: navState?.clientCode || "",
                                                                    clientCode: role === USER_ROLES.RM ? navState?.clientCode : investorClientId,
                                                                    portfolioId: navState?.portfoiloId || ""
                                                                })} variant="body_500" sx={{
                                                                    letterSpacing: '0.01px',
                                                                }}>
                                                                    View Profile
                                                                </Typography>
                                                                <ViewProfileIcon className="view-profile-icon" />
                                                            </Button>
                                                        </>
                                                    }
                                                </Box>
                                            </Box>
                                        </Box>
                                    </Grid>
                                    <Grid item md={5} sm={12}>
                                        <Box component={'div'} sx={{ display: { sm: 'flex', md: 'block' }, justifyContent: { sm: 'space-between', xl: 'normal' }, mb: { xs: '10px' }, textAlign: { sm: 'left', md: 'right' } }}>
                                            <Box>
                                                <Typography variant="body_500" color='text.primary'>Market Value</Typography>
                                                <Typography variant="subtitle_500" color="text.secondary">{`as on ${formattedBusinessDate}`}</Typography>
                                            </Box>

                                            <Typography variant="h1" sx={(theme: Theme) => ({
                                                color: theme.palette.primary[500],
                                                lineHeight: '40px',
                                                mt: '5px'
                                            })}>{toINR({ value: investorInfo?.marketValue, locale, currencyCode })}</Typography>
                                        </Box>
                                    </Grid>
                                    {/* Investor Details */}
                                    <Grid item xs={12} lg={6}>
                                        <Box component={'section'} sx={{ display: { lg: 'block', xs: 'flex' }, flexWrap: 'wrap', alignItems: 'center', justifyContent: 'flex-start', gap: '10px' }}>
                                            {investorInfo?.investorType === 'Joint' && (
                                                <Box sx={{ display: 'flex', alignItems: 'center', columnGap: '10px', mb: '15px' }}>
                                                    <JointHoldersDisplayIcon />
                                                    {investorInfo?.applicantNames.map((name: string, index: number) => (
                                                        <Typography
                                                            key={index}
                                                            component={'span'}
                                                            variant="body_500"
                                                            color='text.primary'
                                                            sx={{ letterSpacing: '0.02px', textTransform: 'capitalize' }}
                                                        >
                                                            {name.toLowerCase().replace(/\b\w/g, char => char.toUpperCase())}
                                                            {index === 0 && investorInfo?.applicantNames?.length > 1 && ','}
                                                        </Typography>
                                                    ))}
                                                </Box>
                                            )}
                                            <Box sx={{ display: 'flex', alignItems: 'center', columnGap: '10px', mb: '15px' }}>
                                                <EmailIcon />
                                                <Typography component={'span'} variant="body_500" color='text.primary' sx={{ letterSpacing: '0.02px' }}>{investorInfo?.emailId}</Typography>
                                            </Box>
                                            <Box sx={{ display: 'flex', alignItems: 'center', columnGap: '10px', mb: '15px' }}>
                                                <Phoneicon />
                                                <Typography component={'span'} variant="body_500" color='text.primary' sx={{ letterSpacing: '0.02px' }}>{ investorInfo?.mobileNumber?`${investorInfo?.countryCode??"-"} ${investorInfo?.mobileNumber}`:"-"}</Typography>
                                            </Box>
                                            <Box sx={{ display: 'flex', alignItems: 'center', columnGap: '10px', mb: '15px' }}>
                                                <JointHolderIcon />
                                                <Typography component={'span'} variant="body_500" color='text.primary' sx={{ letterSpacing: '0.02px' }}>{investorInfo?.rm}</Typography>
                                            </Box>


                                        </Box>

                                        <Grid
                                            item
                                            xs={12}
                                            // lg={6}
                                            container
                                            sx={{
                                                flexDirection: "row",
                                                alignItems: 'center',
                                                justifyContent: 'flex-start',
                                            }}
                                        >
                                            <Box
                                                sx={{
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    columnGap: '10px',
                                                    // marginBottom: { xs: '5px', lg: '10px' }
                                                }}
                                            >
                                                <Typography
                                                    variant="body_500"
                                                    color='text.primary'
                                                    sx={{ letterSpacing: '0.02px' }}
                                                >
                                                    MF Transaction Status:
                                                </Typography>
                                                <Typography
                                                    variant="body_500"
                                                    color={bseStarStatusColorMap[`${investorInfo?.bseClientActivationStatus ?? ""}`.toLowerCase()] ?? 'text.primary'}
                                                    sx={{
                                                        letterSpacing: '0.02px',
                                                        textTransform: "capitalize"
                                                    }}
                                                >
                                                    {investorInfo?.bseClientActivationStatus ?? 'N/A'}
                                                </Typography>
                                            </Box>
                                            {/* <Box>
                                            <Tooltip
                                                slotProps={{
                                                    tooltip: {
                                                        sx: {
                                                            margin: "0px !important",
                                                            backgroundColor: "transparent"
                                                        }
                                                    }
                                                }}
                                                title={
                                                    <Box sx={(theme: Theme) => ({
                                                        borderRadius: '10px',
                                                        backgroundColor: theme.palette.common.tooltipBg,
                                                        padding: '10px',
                                                        display: 'flex',
                                                        flexDirection: 'column',
                                                        rowGap: '10px'  // Gap between each section
                                                    })}>
                                                        <Box sx={(theme: Theme) => ({ borderBottom: `1px solid ${theme.palette.primary[200]}`, paddingBottom: 1, marginBottom: 1 })}>
                                                            <Typography variant='subtitle_500' sx={(theme: Theme) => ({ fontWeight: '600', marginBottom: '5px', color: theme.palette.primary[500] })}>
                                                                CLIENT CREATION RESPONSE
                                                            </Typography>
                                                            <Typography variant='subtitle_600' sx={(theme: Theme) => ({ color: theme.palette.primary[200], fontWeight: '400' })}>
                                                                {investorInfo?.acceptedByBseStar ? 'SUCCESS' : investorInfo?.bseStarResponse ?? '-'}
                                                            </Typography>
                                                        </Box>
                                                        <Box sx={(theme: Theme) => ({ borderBottom: `1px solid ${theme.palette.primary[200]}`, paddingBottom: 1, marginBottom: 1 })}>
                                                            <Typography variant='subtitle_500' sx={(theme: Theme) => ({ fontWeight: '600', marginBottom: '5px', color: theme.palette.primary[500] })}>
                                                                FATCA RESPONSE
                                                            </Typography>
                                                            <Typography variant='subtitle_600' sx={(theme: Theme) => ({ color: theme.palette.primary[200], fontWeight: '400' })}>
                                                                {investorInfo?.acceptedByBseStarFatca ? 'SUCCESS' : investorInfo?.bseFatcaResponse ?? '-'}
                                                            </Typography>
                                                        </Box>
                                                        <Box sx={(theme: Theme) => ({ borderBottom: `1px solid ${theme.palette.primary[200]}`, paddingBottom: 1, marginBottom: 1 })}>
                                                            <Typography variant='subtitle_500' sx={(theme: Theme) => ({ fontWeight: '600', marginBottom: '5px', color: theme.palette.primary[500] })}>
                                                                CHEQUE UPLOAD RESPONSE
                                                            </Typography>
                                                            <Typography variant='subtitle_600' sx={(theme: Theme) => ({ color: theme.palette.primary[200], fontWeight: '400' })}>
                                                                {investorInfo?.cancelChequeUploadAcceptedByBseStar ? 'SUCCESS' : investorInfo?.cancelChequeUploadResponse ?? '-'}
                                                            </Typography>
                                                        </Box>
                                                        <Box sx={(theme: Theme) => ({ borderBottom: `1px solid ${theme.palette.primary[200]}`, paddingBottom: 1, marginBottom: 1 })}>
                                                            <Typography variant='subtitle_500' sx={(theme: Theme) => ({ fontWeight: '600', marginBottom: '5px', color: theme.palette.primary[500] })}>
                                                                AOF IMAGE RESPONSE
                                                            </Typography>
                                                            <Typography variant='subtitle_600' sx={(theme: Theme) => ({ color: theme.palette.primary[200], fontWeight: '400' })}>
                                                                {investorInfo?.aofImageUploadAcceptedByBseStar ? 'SUCCESS' : investorInfo?.bseAofImageResponse ?? '-'}
                                                            </Typography>
                                                        </Box>
                                                        <Box sx={(theme: Theme) => ({ borderBottom: `1px solid ${theme.palette.primary[200]}`, paddingBottom: 1, marginBottom: 1 })}>
                                                            <Typography variant='subtitle_500' sx={(theme: Theme) => ({ fontWeight: '600', marginBottom: '5px', color: theme.palette.primary[500] })}>
                                                                MPOWER STATUS
                                                            </Typography>
                                                            <Typography variant='subtitle_600' sx={(theme: Theme) => ({ color: theme.palette.primary[200], fontWeight: '400' })}>
                                                                {investorInfo?.acceptedByMpower ? 'SUCCESS' : investorInfo?.mpowerResponse ?? '-'}
                                                            </Typography>
                                                        </Box>
                                                        <Box sx={(theme: Theme) => ({ borderBottom: `1px solid ${theme.palette.primary[200]}`, paddingBottom: 1, marginBottom: 1 })}>
                                                            <Typography variant='subtitle_500' sx={(theme: Theme) => ({ fontWeight: '600', marginBottom: '5px', color: theme.palette.primary[500] })}>
                                                                ELOG STATUS
                                                            </Typography>
                                                            <Typography variant='subtitle_600' sx={(theme: Theme) => ({ color: theme.palette.primary[200], fontWeight: '400' })}>
                                                                {investorInfo?.elogStatus ?? '-'}
                                                            </Typography>
                                                        </Box>
                                                        <Box sx={(theme: Theme) => ({ borderBottom: `1px solid ${theme.palette.primary[200]}`, paddingBottom: 1, marginBottom: 1 })}>
                                                            <Typography variant='subtitle_500' sx={(theme: Theme) => ({ fontWeight: '600', marginBottom: '5px', color: theme.palette.primary[500] })}>
                                                                ELOG STATUS APPLICANT 1
                                                            </Typography>
                                                            <Typography variant='subtitle_600' sx={(theme: Theme) => ({ color: theme.palette.primary[200], fontWeight: '400' })}>
                                                                {investorInfo?.elogResponse1 === '' ? '-' : investorInfo?.elogResponse1 ?? '-'}
                                                            </Typography>
                                                        </Box>
                                                        <Box sx={(theme: Theme) => ({ borderBottom: `1px solid ${theme.palette.primary[200]}`, paddingBottom: 1, marginBottom: 1 })}>
                                                            <Typography variant='subtitle_500' sx={(theme: Theme) => ({ fontWeight: '600', marginBottom: '5px', color: theme.palette.primary[500] })}>
                                                                ELOG STATUS APPLICANT 2
                                                            </Typography>
                                                            <Typography variant='subtitle_600' sx={(theme: Theme) => ({ color: theme.palette.primary[200], fontWeight: '400' })}>
                                                                {investorInfo?.elogResponse2 === '' ? '-' : investorInfo?.elogResponse2 ?? '-'}
                                                            </Typography>
                                                        </Box>
                                                        <Box>
                                                            <Typography variant='subtitle_500' sx={(theme: Theme) => ({ fontWeight: '600', marginBottom: '5px', color: theme.palette.primary[500] })}>
                                                                ELOG STATUS APPLICANT 3
                                                            </Typography>
                                                            <Typography variant='subtitle_600' sx={(theme: Theme) => ({ color: theme.palette.primary[200], fontWeight: '400' })}>
                                                                {investorInfo?.elogResponse3 === '' ? '-' : investorInfo?.elogResponse3 ?? '-'}
                                                            </Typography>
                                                        </Box>
                                                    </Box>
                                                }
                                            >
                                                <IconButton>
                                                    <InfoIconOutlined />
                                                </IconButton>
                                            </Tooltip>
                                        </Box> */}
                                            {/* <Box
                                            sx={{
                                                display: 'flex',
                                                alignItems: 'center',
                                                columnGap: '10px',
                                            }}
                                        >
                                            <Typography
                                                variant="body_500"
                                                color='text.primary'
                                                sx={{ letterSpacing: '0.02px' }}
                                            >
                                                MPower Status:
                                            </Typography>
                                            <Typography
                                                variant="body_500"
                                                color={investorInfo?.acceptedByMpower ? 'success.500' : 'warning.500'}
                                                sx={{ letterSpacing: '0.02px' }}
                                            >
                                                {investorInfo?.acceptedByMpower ? 'Active' : 'Pending'}
                                            </Typography>
                                        </Box>  */}
                                        </Grid>
                                    </Grid>

                                    <Grid item xs={12} lg={6} sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'flex-end' }}>
                                        <Grid item xs={12} sx={{ display: 'flex', alignSelf: 'flex-end', justifySelf: 'flex-end' }}>
                                            <Box
                                                sx={{
                                                    display: "flex",
                                                    alignItems: "center"
                                                }}
                                            >
                                                <Typography
                                                    variant="subtitle_500"
                                                    color="text.primary"
                                                >
                                                    Absolute Return
                                                </Typography>
                                                <Switch
                                                    checked={isToggleIrr}
                                                    onChange={handleToggleChange}
                                                    sx={(theme: Theme) => ({
                                                        transform: {
                                                            xs: "scale(0.7)",
                                                            md: "scale(0.9)",
                                                            lg: "scale(1)"
                                                        },
                                                        "& .MuiSwitch-switchBase, & .MuiSwitch-switchBase.Mui-checked": {
                                                            color: theme.palette.primary[500],
                                                        },
                                                        "& .MuiSwitch-track, & .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": {
                                                            backgroundColor: theme.palette.primary[500],
                                                        },
                                                    })}
                                                />
                                                <Typography
                                                    variant="subtitle_500"
                                                    color="text.primary"
                                                >
                                                    XIRR
                                                </Typography>
                                            </Box>
                                        </Grid>
                                        <Box sx={{ display: 'flex', columnGap: '20px', justifyContent: { xs: 'flex-start', lg: 'flex-end' } }}>
                                            <Box>
                                                <Typography variant="subtitle_500" color="text.primary" sx={{ textAlign: { md: 'left', lg: 'right' } }}>Inflow - Outflow</Typography>
                                                <Typography variant="h2" sx={(theme: Theme) => ({
                                                    color: investorInfo?.cashflow > -1 ? theme.palette.success[500] : theme.palette.error[500],
                                                    fontSize: { xs: '14px', md: '16px', lg: '20px' },
                                                    textWrap: 'nowrap'
                                                })}>{investorInfo?.cashflow === 0 ? `${toINR({ value: investorInfo?.cashflow, locale, currencyCode })}` : investorInfo?.cashflow > 0 ? `${formatCurrency({ value: investorInfo?.cashflow, locale, currencyCode })}` : `- ${formatCurrency({ value: Math.abs(investorInfo?.cashflow), locale, currencyCode })}`}</Typography>
                                            </Box>
                                            <Box>
                                                <Typography variant="subtitle_500" color="text.primary" sx={{ textAlign: { md: 'left', lg: 'center' } }}>Gain/Loss</Typography>
                                                <Typography variant="h2" sx={(theme: Theme) => ({
                                                    color: investorInfo?.["gain/loss"] > -1 ? theme.palette.success[500] : theme.palette.error[500],
                                                    fontSize: { xs: '14px', md: '16px', lg: '20px' },
                                                    textWrap: 'nowrap'
                                                })}>{investorInfo?.["gain/loss"] === 0 ? `${toINR({ value: investorInfo?.["gain/loss"], locale, currencyCode })}` : investorInfo?.["gain/loss"] > 0 ? `+ ${formatCurrency({ value: investorInfo?.["gain/loss"], locale, currencyCode })}` : `- ${formatCurrency({ value: Math.abs(investorInfo?.["gain/loss"]), locale, currencyCode })}`}</Typography>
                                            </Box>
                                            <Box>
                                                <Typography variant="subtitle_500" color="text.primary" sx={{ textAlign: { md: 'left', lg: 'center' } }}>
                                                    {isToggleIrr ? "XIRR" : "Absolute Return"}
                                                </Typography>
                                                <Typography variant="h2" sx={(theme: Theme) => ({
                                                    color: Number(toggleValue ?? "") > -1 ? theme.palette.success[500] : theme.palette.error[500],
                                                    fontSize: { xs: '14px', md: '16px', lg: '20px' },
                                                    textWrap: 'nowrap',
                                                    display: 'flex', alignItems: 'flex-end', justifyContent: 'flex-end'
                                                })}>
                                                    {Number(toggleValue ?? "") === 0 ? '0%' : `${Number(toggleValue ?? "").toFixed(2)}%`}
                                                </Typography>
                                            </Box>

                                        </Box>
                                    </Grid>
                                </Grid>
                            }


                            {/* Asset Classes */}

                            <Box sx={{
                                mt: '20px',
                                display: 'flex',
                                alignItems: 'center',
                                // justifyContent: { lg: "space-between", xs: "flex-start" },
                                flexWrap: "wrap"
                            }}>
                                {assestPercentages?.map((item, index) => {
                                    return (
                                        <React.Fragment key={index}>
                                            <Button
                                                sx={(theme: Theme) => ({
                                                    maxWidth: "fit-content",
                                                    padding: '5px 10px',
                                                    borderRadius: '5px',
                                                    '&:hover': {
                                                        backgroundColor: assetClassLoader || investorInfoLoading ? 'unset' : theme.palette.primary[50],
                                                    },
                                                    '&:disabled': {
                                                        opacity: 0.5,
                                                        cursor: "not-allowed",
                                                        pointerEvents: "all"
                                                    }
                                                })}
                                                onClick={assetClassLoader || investorInfoLoading ? () => { '' } : () => handleAssetClassNavigation(index)}
                                                disabled={!investorInfo?.isSuccess || !item.isShow}
                                            >
                                                <Box
                                                    sx={{
                                                        display: "flex",
                                                        columnGap: "5px",
                                                        alignItems: 'center'
                                                    }}
                                                >
                                                    <Box>
                                                        {assetClassLoader || investorInfoLoading ? <Skeleton animation="wave" variant="rectangular" height={20} width={20} sx={{ borderRadius: '5px' }} /> : assetClassIconMap[index]}
                                                    </Box>
                                                    {assetClassLoader || investorInfoLoading ? <Skeleton animation="wave" sx={{ width: '80px' }} /> : <Typography
                                                        variant="body_500"
                                                        color="text.secondary"
                                                        sx={(theme: Theme) => ({
                                                            letterSpacing: '0.05px',

                                                            '&:hover': {
                                                                color: theme.palette.primary[500],

                                                            }
                                                        })}
                                                    >
                                                        {item.name}
                                                    </Typography>}
                                                </Box>
                                                {assetClassLoader || investorInfoLoading ? <Skeleton animation="wave" variant="rectangular" width={15} height={15} sx={{ ml: '10px' }} /> : <>
                                                    {item.isShowValue ? ((investedValueCheck) ? <ZeroStateArrow /> : item.value < 0 ? <DownwardNegativeIcon /> : <UpWardPositiveIcon />) : <ZeroStateArrow />}
                                                    {(!investedValueCheck && item.isShowValue) && <Typography
                                                        variant="body_500"
                                                        sx={(theme: Theme) => ({
                                                            color: (investedValueCheck) ? theme.palette.text.primary : item.value < 0 ? theme.palette.error[500] : theme.palette.success[500],
                                                        })}
                                                    >
                                                        {item.value}%
                                                    </Typography>}
                                                </>}
                                            </Button>
                                            {assetClassLoader || investorInfoLoading ? <Skeleton animation="wave" height={30} width={5} sx={{ display: index !== 4 ? 'block' : 'none', }} /> : <Box
                                                sx={(theme: Theme) => ({
                                                    height: '15px',
                                                    width: "1px",
                                                    backgroundColor: `${theme.palette.text.secondary}B2`,
                                                    display: index !== 5 ? 'block' : 'none',
                                                })}
                                            />}
                                        </React.Fragment>

                                    )
                                })}

                            </Box>
                        </Box>

                        {/* Three Cards */}

                        <Box columnGap={2} rowGap={2} mt={'25px'}
                            sx={{
                                display: 'flex',
                                flexDirection: { xs: 'column', md: 'row' },
                                flexWrap: 'unwrap',
                                justifyContent: 'space-between',
                                alignItems: 'center',
                            }}
                        >
                            {investorPortfolioCards.map((item, index) => {
                                return (
                                    <Box key={index} sx={(theme: Theme) => ({
                                        padding: '20px 30px',
                                        borderRadius: '10px',
                                        // borderRadius: '15px',
                                        // padding: '25px 18px',
                                        // boxShadow: `0px 4px 10px ${alpha(theme.palette.common.black, 0.05)}`,
                                        // border: `3px solid ${theme.palette.stroke.main}`,
                                        background: theme.palette.common.white,
                                        display: 'flex',
                                        alignItems: 'center',
                                        gap: '15px',
                                        width: '100%',
                                    })}>
                                        <Box>
                                            {investorInfoLoading ? <Skeleton animation="wave" variant="rectangular" width={40} height={40} sx={{ borderRadius: '10px' }} /> : index === 0 && <InvestedValueIcon /> || index === 1 && <CashAvailablePortfolioIcon /> || index === 2 && <WeightedAvgDaysIcon />}
                                        </Box>
                                        <Box sx={{ width: '100%', }}>
                                            {investorInfoLoading ?
                                                <Skeleton animation="wave" width="60%" />
                                                :
                                                <Typography color="text.primary"
                                                    sx={
                                                        {
                                                            mb: '5px',
                                                            fontWeight: 300,
                                                            fontSize: { xl: '16px', lg: '14px', md: '12px', sm: '14px', xs: '12px' },
                                                        }
                                                    }
                                                >
                                                    {item.label}
                                                </Typography>}
                                            {investorInfoLoading ?
                                                <Skeleton animation="wave" width="100%" />
                                                :
                                                <Typography color="text.primary"
                                                    sx={
                                                        {
                                                            fontWeight: 600,
                                                            fontSize: { xl: '22px', lg: '16px', md: '16px', sm: '14px', xs: '12px' },
                                                        }
                                                    }
                                                >
                                                    {item.value}
                                                </Typography>}
                                        </Box>

                                    </Box>
                                    // </Box>
                                )
                            })}
                            {/* </Box> */}

                        </Box>

                    </Grid >

                    {/* Risk Score */}
                    < Grid item md={12} lg={4} sx={{ mt: { xs: '25px', lg: '0' }, width: '100%', }
                    }>
                        <Box component={'section'} sx={(theme: Theme) => ({
                            padding: '20px 30px',
                            borderRadius: '10px',
                            // borderRadius: '25px',
                            // padding: '35px',
                            // boxShadow: `0px 4px 10px ${alpha(theme.palette.common.black, 0.05)}`,
                            // border: `3px solid ${theme.palette.stroke.main}`,
                            background: theme.palette.common.white,
                            height: "100%"
                        })}>
                            {riskScoreLoading && (
                                // <>
                                //     <Skeleton animation="wave" sx={{ width: '50%', height: '40px' }} />
                                //     <Box sx={{ mt: { xl: '40px', xs: '20px' } }}>
                                //         <Skeleton animation="wave" variant="circular" sx={{ width: '100%', height: '290px', mt: '35px' }} />
                                //         <Box sx={{ textAlign: 'center', mt: '35px' }}>
                                //             <Skeleton animation="wave" sx={{ width: '70%', textAlign: 'center' }} />
                                //             <Skeleton animation="wave" sx={{ width: '50%' }} />
                                //         </Box>
                                //     </Box>
                                // </>
                                <Box
                                    sx={{
                                        display: "flex",
                                        flexDirection: "column",
                                        height: "100%",
                                        minHeight: { xs: "500px", lg: "0px" },
                                        rowGap: "15px"
                                    }}
                                >
                                    <Box
                                        sx={{
                                            display: "flex",
                                            justifyContent: "space-between",
                                            alignItems: "center"
                                        }}
                                    >
                                        <Skeleton
                                            component="div"
                                            animation="wave"
                                            sx={(theme: Theme) => ({
                                                width: "30%",
                                                ...theme.typography.h2
                                            })}
                                        />
                                        {/* {(role === USER_ROLES.RM) && ( */}
                                        {/* <Skeleton
                                        component="div"
                                        variant="circular"
                                        animation="wave"
                                        sx={{
                                            width: "40px",
                                            height: "40px"
                                        }}
                                    /> */}
                                        {/* )} */}
                                    </Box>
                                    <Box
                                        sx={{
                                            flexGrow: 1,
                                            display: "flex",
                                            justifyContent: "center",
                                            alignItems: "center"
                                        }}
                                    >
                                        <Skeleton
                                            component="div"
                                            variant="circular"
                                            animation="wave"
                                            sx={{
                                                width: { xs: "50%", lg: "65%" },
                                                height: "100%"
                                            }}
                                        />
                                    </Box>
                                    <Box
                                        sx={{
                                            marginTop: "10px",
                                            display: "flex",
                                            flexDirection: "column",
                                            rowGap: "10px",
                                            justifyContent: "center",
                                            alignItems: "center"
                                        }}
                                    >
                                        <Skeleton
                                            component="div"
                                            animation="wave"
                                            sx={(theme: Theme) => ({
                                                width: "30%",
                                                ...theme.typography.body_500
                                            })}
                                        />
                                        <Skeleton
                                            component="div"
                                            animation="wave"
                                            sx={(theme: Theme) => ({
                                                width: "30%",
                                                ...theme.typography.h1
                                            })}
                                        />
                                        <Skeleton
                                            component="div"
                                            animation="wave"
                                            sx={(theme: Theme) => ({
                                                width: "50%",
                                                ...theme.typography.body_400
                                            })}
                                        />
                                    </Box>
                                </Box>
                            )}

                            {!riskScoreLoading && (
                                // <>
                                //     <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                                //         <Typography variant="h2" color="text.primary" sx={{ letterSpacing: '0.01px', lineHeight: '25px' }}>
                                //             Risk Score
                                //         </Typography>
                                //         {(role === USER_ROLES.RM) && (
                                //             // <IconButton onClick={openEditRiskProfile} sx={{ cursor: 'pointer', fontSize: '25px' }}>
                                //             //     <BlueEditIcon />
                                //             // </IconButton>
                                //             <IconButton
                                //                 sx={{
                                //                     width: "40px",
                                //                     height: "40px"
                                //                 }}
                                //             >
                                //                 <CardMedia
                                //                     component="img"
                                //                     src="/images/edit-icon-outlined.svg"
                                //                     alt="Edit Icon"
                                //                     sx={{ width: 'unset' }}
                                //                     onClick={openEditRiskProfile}
                                //                 />
                                //             </IconButton>
                                //         )}
                                //     </Box>
                                //     <Box sx={{ mt: { xl: '40px', xs: '20px' } }}>
                                //         {investorInfo?.riskScore > 0 ? (
                                //             <>
                                //                 <CustomGaugeChart data={Number(investorInfo?.riskScore)} />
                                //                 <Box sx={{ textAlign: 'center', mt: '35px' }}>
                                //                     <Typography variant="body_500" color={'text.secondary'} sx={{ mb: '10px' }}>
                                //                         Risk tolerance is
                                //                     </Typography>
                                //                     <Typography variant="h1" sx={(theme: Theme) => ({
                                //                         color: theme.palette.primary[500]
                                //                     })}>
                                //                         {findRiskTolerance(investorInfo?.profile)}
                                //                     </Typography>
                                //                     <Typography
                                //                         variant="body_400"
                                //                         sx={(theme: Theme) => ({
                                //                             color: theme.palette.text.secondary,
                                //                             mt: 2
                                //                         })}
                                //                     >
                                //                         <Typography
                                //                             component="span"
                                //                             sx={{ fontWeight: "600" }}
                                //                         >
                                //                             {`Expiry Date: `}
                                //                         </Typography>
                                //                         {investorInfo?.riskProfileExpiryDate ? dayjs(investorInfo?.riskProfileExpiryDate).format('DD/MM/YYYY') : ""}
                                //                     </Typography>
                                //                 </Box>
                                //             </>
                                //         ) : (
                                //             <Box
                                //                 component="img"
                                //                 src="/images/riskProfile.svg"
                                //                 alt="Risk Profile"
                                //                 width={'100%'}
                                //                 height={'100%'}
                                //                 sx={{ objectFit: "contain" }}
                                //             />
                                //         )}
                                //     </Box>
                                // </>
                                <Box
                                    sx={{
                                        display: "flex",
                                        flexDirection: "column",
                                        height: "100%",
                                        minHeight: { xs: "500px", lg: "0px" },
                                        rowGap: "15px"
                                    }}
                                >
                                    <Box
                                        sx={{
                                            display: "flex",
                                            justifyContent: "space-between",
                                            alignItems: "center"
                                        }}
                                    >
                                        <Typography
                                            variant="h2"
                                            color="text.primary"
                                            sx={{
                                                letterSpacing: '0.01px',
                                                lineHeight: '25px'
                                            }}
                                        >
                                            Risk Score
                                        </Typography>
                                        {/* {(role === USER_ROLES.RM) && ( */}
                                        {/* <IconButton
                                        sx={{
                                            width: "48px",
                                            height: "48px"
                                        }}
                                        onClick={openEditRiskProfile}
                                    >
                                        <CardMedia
                                            component="img"
                                            src="/images/edit-icon-outlined.svg"
                                            alt="Edit Icon"
                                            sx={{ width: 'unset' }}
                                            onClick={openEditRiskProfile}
                                        />
                                        <EditOulineIcon />
                                    </IconButton> */}
                                        {/* )} */}
                                    </Box>
                                    {investorInfo?.riskScore > 0 ? (
                                        <>
                                            <Box
                                                sx={{
                                                    flexGrow: 1,
                                                    display: "flex",
                                                    justifyContent: "center",
                                                    alignItems: "center"
                                                }}
                                            >
                                                <CustomGaugeChart
                                                    data={Number(investorInfo?.riskScore)}
                                                    company={investorInfo?.application?.company ?? null}
                                                    riskProfileGroup={investorInfo?.application?.applicants?.[0]?.riskProfileGroup ?? null}
                                                />
                                            </Box>
                                            <Box
                                                sx={{
                                                    marginTop: "10px",
                                                    display: "flex",
                                                    flexDirection: "column",
                                                    rowGap: "10px",
                                                    justifyContent: "center",
                                                    alignItems: "center"
                                                }}
                                            >
                                                <Typography
                                                    variant="body_500"
                                                    color='text.secondary'
                                                >
                                                    Risk tolerance is
                                                </Typography>
                                                <Typography
                                                    variant="h1"
                                                    sx={(theme: Theme) => ({
                                                        color: theme.palette.primary[500]
                                                    })}
                                                >
                                                    {investorInfo?.profile}
                                                </Typography>
                                                <Typography
                                                    variant="body_400"
                                                    sx={(theme: Theme) => ({
                                                        color: theme.palette.text.secondary,
                                                    })}
                                                >
                                                    <Typography
                                                        component="span"
                                                        sx={{ fontWeight: "600" }}
                                                    >
                                                        {`Expiry Date: `}
                                                    </Typography>
                                                    {investorInfo?.riskProfileExpiryDate ? dayjs(investorInfo?.riskProfileExpiryDate).format('DD/MM/YYYY') : ""}
                                                </Typography>
                                            </Box>
                                        </>)
                                        : (
                                            <Box
                                                component="img"
                                                src="/images/riskProfile.svg"
                                                alt="Risk Profile"
                                                width={'100%'}
                                                height={'100%'}
                                                sx={{ objectFit: "contain" }}
                                            />
                                        )}
                                </Box>
                            )}
                        </Box>
                    </Grid >
                </Grid >

                {
                    (!investorInfoLoading && zeroStateCheck) ?
                        <Box
                            sx={(theme: Theme) => ({
                                backgroundColor: theme.palette.common.white,
                                borderRadius: "25px",
                                padding: "25px 30px",
                                height: "50vh",
                                mt: '25px'
                            })}
                        >
                            <ZeroStateInvestment isSuccess={zeroStateCheck} />
                        </Box>
                        :
                        <>
                            {/* Portfolio Health and Notifications */}
                            <Grid container sx={{ mt: '25px' }} rowGap={2} columnSpacing={3} height={'100%'}>

                                {/* Portfolio Health Chart*/}
                                {investedValueCheck ?
                                    <Grid item sm={12} lg={6.5} sx={{
                                        width: '100%'
                                    }}>
                                        <Box
                                            sx={(theme: Theme) => ({
                                                padding: '20px 30px',
                                                borderRadius: '10px',
                                                backgroundColor: theme.palette.common.white,
                                                // borderRadius: "25px",
                                                // padding: "25px 30px",
                                                height: '100%',
                                                // border: `3px solid ${palette.stroke.main}`
                                            })}
                                        >
                                            <ZeroStateInvestment isSuccess={investedValueCheck} />
                                        </Box>
                                    </Grid>
                                    :
                                    <Grid item sm={12} lg={6.5} sx={{ width: '100%' }}>
                                        <PortfolioHealthChart
                                            isLoading={investorInfoLoading || benchmarkPerformanceLoader}
                                            getAllData={performanceData?.result}
                                            dynamicY={true}
                                            success={performanceData?.isSuccess}
                                        />

                                    </Grid>
                                }
                                {/* Notifications */}
                                <Grid item md={12} lg={5.5} sx={{ mt: { xs: '25px', md: 0 }, width: '100%' }}>
                                    <Box sx={(theme: Theme) => ({
                                        padding: '20px 30px',
                                        borderRadius: '10px',
                                        // borderRadius: '25px',
                                        // padding: '25px 30px',
                                        // boxShadow: `0px 4px 10px ${alpha(theme.palette.common.black, 0.05)}`,
                                        // border: `3px solid ${theme.palette.stroke.main}`,
                                        background: theme.palette.common.white,
                                        height: '100%'
                                    })}>
                                        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: '35px' }}>
                                            <Typography variant="h2" color="text.primary" sx={{ letterSpacing: '0.01px', lineHeight: '25px' }}>Notifications</Typography>
                                        </Box>
                                        {(notificationsLoader || investorInfoLoading) &&
                                            <Box>
                                                {[...Array(5)].map((_, index) => (
                                                    <React.Fragment key={index}>
                                                        <Box sx={{ display: 'flex', justifyContent: 'space-between', columnGap: '15px', width: '100%', mb: '50px' }}>
                                                            <Box sx={{ display: 'flex', columnGap: '15px', flexDirection: 'row', width: '100%' }}>
                                                                <Box>
                                                                    <Skeleton animation="wave" variant="rectangular" width={25} height={25} />
                                                                </Box>
                                                                <Box sx={{ display: 'flex', flexDirection: 'column', width: '100%' }}>
                                                                    <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', width: '100%' }}>
                                                                        <Box>
                                                                            <Skeleton animation="wave" width={200} />
                                                                        </Box>
                                                                        <Box>
                                                                            <Box sx={{ display: 'flex', columnGap: '5px' }}>
                                                                                <Skeleton animation="wave" width={150} />
                                                                            </Box>
                                                                        </Box>
                                                                    </Box>
                                                                    <Box>
                                                                        <Skeleton animation="wave" width={200} />
                                                                    </Box>
                                                                </Box>
                                                            </Box>
                                                        </Box>
                                                    </React.Fragment>
                                                ))}

                                            </Box>
                                        }
                                        {(!notificationsLoader && !investorInfoLoading) && notifications?.length === 0 && (
                                            <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                                <Typography variant="body_600" color={'text.primary'} sx={{ textAlign: 'center', fontWeight: 500 }}>No Data Found</Typography>
                                            </Box>
                                        )}
                                        {(!notificationsLoader && !investorInfoLoading) && notifications?.length > 0 &&
                                            <Box >
                                                {notifications?.map((notification, index) => {
                                                    const timestamp = !Number.isNaN(Number(notification.timestamp)) ? Number(notification.timestamp) : 0
                                                    const dayjsObj = dayjs(timestamp)
                                                    const notificationDate = dayjsObj.format('DD MMM, YY')
                                                    const notificationTime = dayjsObj.format('hh:mm A')
                                                    return (
                                                        <Box key={index} sx={(theme: Theme) => ({ padding: index === 0 ? '0 0 20px 0' : '20px 0', display: 'flex', justifyContent: 'space-between', borderBottom: index !== 4 ? `0.5px solid ${theme.palette.text.secondary}B2` : 0, })}>
                                                            <Box sx={{ display: 'flex', justifyContent: 'space-between', columnGap: '15px', width: '100%' }}>
                                                                <Box sx={{ display: 'flex', columnGap: '15px', flexDirection: 'row', width: '100%', }}>
                                                                    <Box >
                                                                        {isLoading ? <Skeleton animation="wave" variant="rectangular" width={25} height={25} sx={{ borderRadius: '50%' }} /> : notification?.type === "01" ? <SuccessTickIcon /> : notification?.type === '02' ? <InProgressIcon width="20" height="30" /> : notification.type === '03' ? <FailureIcon width="20" height="30" /> : <SuccessTickIcon />}
                                                                    </Box>
                                                                    <Box sx={{ display: 'flex', flexDirection: 'column', width: '100%', }}>
                                                                        <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', width: '100%', }}>
                                                                            <Box>
                                                                                {isLoading ? <Skeleton animation="wave" width={200} /> : <Typography variant="body_500" color={'text.primary'} sx={{ fontSize: '18px', letterSpacing: '0.02px', mb: '3px' }}>{notification?.title}</Typography>}
                                                                            </Box>
                                                                            <Box>
                                                                                <Box sx={{ display: 'flex', columnGap: '5px' }}>
                                                                                    {isLoading ? <Skeleton animation="wave" width={150} /> : <>
                                                                                        <Typography variant="subtitle_500" color={'text.secondary'}>{notificationDate}</Typography>
                                                                                        <Typography variant="subtitle_500" color={'text.secondary'}>{notificationTime}</Typography>
                                                                                    </>}
                                                                                </Box>
                                                                            </Box>
                                                                        </Box>
                                                                        <Box >
                                                                            {isLoading ? <Skeleton animation="wave" width={200} /> : <Typography variant="subtitle_500" color={'text.secondary'}
                                                                                sx={{
                                                                                    whiteSpace: "pre-line",
                                                                                    display: "-webkit-box",
                                                                                    overflow: "hidden",
                                                                                    WebkitBoxOrient: "vertical",
                                                                                    WebkitLineClamp: 2,

                                                                                }}
                                                                            >
                                                                                {notification?.subtitle}
                                                                            </Typography>}
                                                                        </Box>
                                                                    </Box>
                                                                </Box>
                                                            </Box>
                                                        </Box>
                                                    )
                                                })}
                                            </Box>
                                        }
                                    </Box>
                                </Grid>
                            </Grid>

                            {/* Asset Allocation and Portfolio Exposure Chart */}

                            {!investedValueCheck &&
                                <Grid container sx={{ mt: '25px' }} columnSpacing={3}>
                                    {/* Asset Allocation Chart */}
                                    <Grid item md={12} lg={6} sx={{ width: '100%' }}>
                                        <Box sx={(theme: Theme) => ({
                                            padding: '20px 30px',
                                            borderRadius: '10px',
                                            // borderRadius: '20px',
                                            // padding: '25px 30px 45px 30px',
                                            // boxShadow: `0px 4px 10px ${alpha(theme.palette.common.black, 0.05)}`,
                                            // border: `3px solid ${theme.palette.stroke.main}`,
                                            background: theme.palette.common.white,
                                            height: '100%'
                                        })}
                                        >
                                            <Box style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
                                                <Typography variant="h2" sx={{
                                                    marginBottom: '40px'
                                                }}>Asset Allocation</Typography>
                                                {/* <CustomDropdown
                                                selectedValue={assetDropdownOptions}
                                                handleValueChange={handleAssetDropdownChange}
                                                isLoading={assetLoading || investorInfoLoading}
                                                dropdownOptions={[
                                                    {
                                                        "label": "By Product",
                                                        "value": 1
                                                    },
                                                    {
                                                        "label": "By Asset Class",
                                                        "value": 2
                                                    }
                                                ]} /> */}
                                                <SwitchSelection
                                                    value={assetDropdownOptions}
                                                    handleOptionChange={handleAssetDropdownChange}
                                                    options={[
                                                        {
                                                            "label": "By Product",
                                                            "value": 1
                                                        },
                                                        {
                                                            "label": "By Asset Class",
                                                            "value": 2
                                                        }
                                                    ]}
                                                    containerStyle={{
                                                        height: '38px',
                                                    }} />

                                            </Box>
                                            {!assetLoading && !investorInfoLoading && !assetAllocation?.isSuccess ?
                                                <Typography
                                                    variant="body_600"
                                                    sx={(theme: Theme) => ({
                                                        fontWeight: 500,
                                                        lineHeight: "22.5px",
                                                        letterSpacing: "0.01px",
                                                        color: theme.palette.text.primary,
                                                        textAlign: 'center'
                                                    })}
                                                >
                                                    {NO_DATA_ERROR_MESSAGE}
                                                </Typography>
                                                :

                                                !assetLoading && (isAssetAllocationError || assetAllocation?.result?.data?.length === 0) ?
                                                    <ErrorText />
                                                    : <CustomePieChart {...{ ...assetAllocation?.result, isLoading: assetLoading, showSlider: true }} />
                                            }
                                        </Box>
                                    </Grid>

                                    {/* Portfolio Exposure Chart */}
                                    <Grid item md={12} lg={6} sx={{ mt: { xs: '25px', md: 0 }, width: '100%', }}>
                                        <Box sx={(theme: Theme) => ({
                                            padding: '20px 30px',
                                            borderRadius: '10px',
                                            // borderRadius: '20px',
                                            // padding: '25px 30px 45px 30px',
                                            // boxShadow: `0px 4px 10px ${alpha(theme.palette.common.black, 0.05)}`,
                                            // border: `3px solid ${theme.palette.stroke.main}`,
                                            background: theme.palette.common.white,
                                            height: '100%'
                                        })}>
                                            <Box style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
                                                <Typography variant="h2" sx={{
                                                    marginBottom: '40px'
                                                }}>Portfolio Exposure</Typography>
                                                {/* <CustomDropdown
                                                selectedValue={portfolioDropdownOptions}
                                                handleValueChange={handlePortfolioChange}
                                                isLoading={portfolioLoading || investorInfoLoading}
                                                dropdownOptions={[
                                                    {
                                                        "label": "Sector Allocation",
                                                        "value": 1
                                                    },
                                                    {
                                                        "label": "Company Exposure",
                                                        "value": 2
                                                    }
                                                ]} /> */}
                                                <SwitchSelection
                                                    value={portfolioDropdownOptions}
                                                    handleOptionChange={handlePortfolioChange}
                                                    options={[
                                                        {
                                                            "label": "Sector Allocation",
                                                            "value": 1
                                                        },
                                                        {
                                                            "label": "Company Exposure",
                                                            "value": 2
                                                        }
                                                    ]}
                                                    containerStyle={{
                                                        height: '38px',
                                                    }}
                                                />

                                            </Box>
                                            {!portfolioLoading && !investorInfoLoading && !portfolioAllocation?.isSuccess ?
                                                <Typography
                                                    variant="body_600"
                                                    sx={(theme: Theme) => ({
                                                        fontWeight: 500,
                                                        lineHeight: "22.5px",
                                                        letterSpacing: "0.01px",
                                                        color: theme.palette.text.primary,
                                                        textAlign: 'center'
                                                    })}
                                                >
                                                    {NO_DATA_ERROR_MESSAGE}
                                                </Typography>
                                                :

                                                !portfolioLoading && (isPortfolioAllocationError || portfolioAllocation?.result?.data?.length === 0) ?
                                                    <ErrorText />
                                                    : <CustomePieChart {...{ ...portfolioAllocation?.result, isLoading: portfolioLoading, showSlider: true }} />
                                            }
                                        </Box>
                                    </Grid>
                                </Grid>
                            }


                            {/* Recent Recommendations Table */}

                            <Box sx={(theme: Theme) => ({
                                padding: '20px 30px',
                                borderRadius: '10px',
                                // borderRadius: '25px',
                                // padding: '25px 30px',
                                // background: theme.palette.common.white,
                                // border: `3px solid ${theme.palette.stroke.main}`,
                                background: theme.palette.common.white,
                                marginTop: '25px'
                            })}>
                                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: '35px' }}>
                                    <Typography variant="h2" color={'text.primary'}>Recent Suggestions</Typography>
                                    <Typography
                                        variant="body_500"
                                        sx={(theme: Theme) => ({
                                            color: theme.palette.primary[500],
                                            cursor: 'pointer'
                                        })}
                                        onClick={() => role === USER_ROLES.RM ? history.push(`${pathName}/mutual-fund?tab=Suggestions`, { clientCode: role === USER_ROLES.RM ? navState?.clientCode : investorClientId }) : history.push('/investor-recommendations')}
                                    >
                                        View All
                                    </Typography>
                                </Box>

                                <Box>
                                    <Hidden only="xs">
                                        <CustomTable
                                            tableBody={
                                                <RecentRecommendationsTableBody
                                                    tableBodyData={recentRecommendationsData}
                                                    tableBodyRowCustomStyles={{
                                                        '& td:first-of-type': {
                                                            paddingLeft: "0px"
                                                        },
                                                    }}
                                                />
                                            }
                                            tableData={recentRecommendationsData}
                                            tableBodyLoaderRowCustomStyles={{
                                                '& td:first-of-type': {
                                                    paddingLeft: "0px"
                                                },
                                            }}
                                            tableHeaderData={tableHeaderData}
                                            handleSort={handleTableSorting}
                                            isPaginationVisible={false}
                                            tableHeadRowCustomStyles={{
                                                '& th:first-of-type': {
                                                    paddingLeft: "0px"
                                                }
                                            }}

                                            tableBodyCustomStyles={{
                                                '& tr:last-child td': {
                                                    border: 0
                                                }
                                            }}
                                            isShowMoreVisible={false}
                                            loadingRowsNum={6}
                                            tableDataCount={recentRecommendationsData?.length}
                                            isLoading={recommendationsLoading || investorInfoLoading}
                                            order={sortingObj.order}
                                            orderBy={sortingObj.orderBy}
                                        />
                                    </Hidden>
                                    <Hidden smUp={true}>
                                        {/* header */}

                                        <TableContainer>
                                            <Table>
                                                <TableHead>
                                                    <TableRow>
                                                        <TableCell align='left' style={{ ...style }}>
                                                            Scheme
                                                        </TableCell>
                                                        <TableCell align='center' style={{ ...style }}>
                                                            <TableSortLabel
                                                                onClick={() => handleHeader()}
                                                                IconComponent={() => <DropDownIcons style={{ marginRight: '5px' }} />} >
                                                                {tableHeaderData.filter((item) => item.id === tableHeaderKey)[0].label}
                                                            </TableSortLabel>
                                                        </TableCell>
                                                    </TableRow>
                                                </TableHead>
                                                <TableBody>
                                                    {recentRecommendationsData?.map((row, i) => (
                                                        <TableRow key={i}>
                                                            <TableCell align='left' style={{ maxWidth: 'calc(100% - 200px - 20px)', paddingLeft: '15px', }}>
                                                                <Typography variant="subtitle_500" color={palette.text.primary} fontWeight={500}>{row.schemeName}</Typography>
                                                            </TableCell>
                                                            <TableCell align='right' style={{ ...style }}>
                                                                <Typography variant="subtitle_500" color={palette.text.primary} fontWeight={500}>{row[tableHeaderKey]}</Typography>
                                                            </TableCell>
                                                        </TableRow>
                                                    ))}
                                                </TableBody>
                                            </Table>
                                        </TableContainer>
                                    </Hidden>
                                </Box>
                                <BottomMenu open={tableHeaderMenu} close={() => setTableHeaderMenu(false)} list={tableHeaderData} setTableHeaderKey={setTableHeaderKey} />

                            </Box>


                            {openRiskScore && <RiskScoreModal open={openRiskScore} close={closeEditRiskProfile} />}

                        </>
                }
            </Box >
        </>
    )
}